var o;!function(o){o.VERTICAL="vertical",o.HORIZONTAL="horizontal"}(o||(o={}));export{o as DirectionType};
//# sourceMappingURL=DividerConstants.js.map
